import React from 'react';

import Container from '../../atoms/Container';
import Footer from '../../molecules/Footer';
import Navbar from '../../molecules/Navbar';
import Content from '../../organisms/Content';

interface IProps {
  match: { isExact: boolean; params: { id: string }; path: string };
}

const ForgotPassword: React.FC<IProps> = ({ match }: IProps) => {
  const { id } = match.params;

  return (
    <Container>
      <Navbar />
      <Content id={id} />
      <Footer />
    </Container>
  );
};

export default ForgotPassword;
